export default __webpack_public_path__ + "static/CGV-formations-wealcome-particuliers-44b0df144f970528b35c67ec17c8ec2f.pdf";